import { PayloadAction, createSlice } from "@reduxjs/toolkit"

import { IBankMeta } from "../../api/interface"

interface ILinkingSlice {
  bank: IBankMeta | null
  amount: {
    value: string
  }
}

const initialState: ILinkingSlice = {
  bank: null,
  amount: {
    value: "",
  },
}

const linkingSlice = createSlice({
  name: "accountLinkingForm",
  initialState,
  reducers: {
    setBank: (state, action: PayloadAction<IBankMeta>) => {
      state.bank = action.payload
    },
    setAmount: (state, action: PayloadAction<string>) => {
      state.amount.value = action.payload
    },
    resetSlice: () => initialState,
  },
})

export const { resetSlice, setBank, setAmount } = linkingSlice.actions

export default linkingSlice.reducer
